/* eslint-disable tailwindcss/no-custom-classname -- Using absolute values to set grid */
import {PrismicNextImage} from '@prismicio/next'
import {SideGridSliceDefaultPrimaryGridCellsItem} from 'prismicio-types'
import {Icon} from 'src/common/Icon'
import cn from 'classnames'

type GridCellProps = {
  content: SideGridSliceDefaultPrimaryGridCellsItem
  isFirst: boolean
  isLast: boolean
  index: number
}

export const GridCell = ({content, isFirst, isLast, index}: GridCellProps) => {
  return (
    <div
      className={`max-md:col-start-${
        index + 2
      } relative col-span-1 ml-[-1px] mt-[-1px] flex flex-col gap-6 rounded-[4px] border border-moss-grey-150 p-4 max-md:row-start-3`}
    >
      {(isFirst || isLast) && (
        <>
          <Icon
            name="corner"
            className={cn('absolute top-[-2px] h-[8px] w-[7px] text-moss-grey-400 max-md:hidden', {
              'right-[-2px] scale-x-[-1] text-moss-grey-400': isLast,
              'left-[-2px] text-moss-grey-400': isFirst,
            })}
          />
          <Icon
            name="corner"
            className={cn('absolute bottom-[-2px] h-[8px] w-[7px] text-moss-grey-400 max-md:hidden', {
              'right-[-2px] rotate-180 text-moss-grey-400': isLast,
              'left-[-2px] scale-y-[-1] text-moss-grey-400': isFirst,
            })}
          />
        </>
      )}
      <span className="text-detail uppercase text-moss-grey-500">{content.title}</span>
      <div className="flex h-full w-full items-center justify-center py-[22px]">
        <PrismicNextImage field={content.asset} className="max-h-[106px] w-auto self-center" />
      </div>
    </div>
  )
}

type GradientProps = {
  color: string
  gradientStart: number
  height: number
  location: 'top' | 'bottom'
  className?: string
}

export const Gradient = ({color, gradientStart, height, location, className}: GradientProps) => {
  return (
    <div
      className={cn('absolute w-full', location === 'top' ? 'top-0' : 'bottom-0', className)}
      style={{
        backgroundImage: `linear-gradient(to ${
          location === 'top' ? 'bottom' : 'top'
        }, rgb(${color}), rgb(${color}) ${gradientStart}%, transparent)`,
        height: `${height}px`,
      }}
    />
  )
}
